interface AnchorTabsProps {
  activeTab: string;
  onTabClick: (id: string) => void;
}

const tabs = [
  { id: 'summary', label: '요약' },
  { id: 'photos', label: '사진' },
  { id: 'reviews', label: '후기' },
  { id: 'info', label: '정보' },
];

export default function AnchorTabs({ activeTab, onTabClick }: AnchorTabsProps) {
  return (
    <div className="sticky top-14 lg:top-0 z-40 bg-white border-b border-[#E8E2DA] shadow-sm">
      <div className="flex py-2 gap-2 lg:py-2 px-4 lg:px-0">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabClick(tab.id)}
            className={`px-4 py-2 rounded-full text-sm md:text-base transition-colors whitespace-nowrap ${
              activeTab === tab.id
                ? 'bg-[#121B35] text-white font-medium'
                : 'text-[#536079] hover:text-[#121B35]'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}